module.exports = __webpack_public_path__ + "img/01—01—Home Network Overview > Ethernet Loop.f29be929.jpg";